module.exports = __webpack_public_path__ + "static/img/9-small.30df7a62.png";